<template>
  <v-banner
    v-show="selected.length"
    single-line
    color="grey lighten-1"
    transition="slide-y-transition"
  >
    <v-btn slot:icon icon @click="$emit('reset-selection')">
      <v-icon :size="iconSize">
        mdi-close
      </v-icon>
    </v-btn>
    {{ selected.length }} {{ massActionSelectedLabel }}

    <template v-slot:actions>
      <v-tooltip v-if="showCrudActions" bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="$emit('mass-delete-action')">
            <v-icon :size="iconSize">
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
        <span v-text="$t('Components.DataTable.MassActionDeleteToolTip')" />
      </v-tooltip>

      <v-divider v-if="showCrudActions" vertical></v-divider>

      <mass-action-menu
        :actions="actions"
        :active-action="activeAction"
        :label="massActionSelectLabel"
        @activate-action="$emit('activate-action', $event)"
        @clear-action="$emit('clear-action')"
      />
      <v-btn
        v-if="activeAction"
        outlined
        icon
        @click="$emit('mass-execute-action')"
      >
        <v-icon :size="iconSize">
          mdi-arrow-right
        </v-icon>
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
import MassActionMenu from "+/components/table/DataTableMassAktionMenu";

export default {
  components: {
    "mass-action-menu": MassActionMenu
  },
  props: {
    selected: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    },
    activeAction: {
      type: Object,
      default: () => {}
    },
    iconSize: {
      type: Number,
      default: 18
    },
    showCrudActions: {
      type: Boolean,
      default: false
    },
    massActionSelectedLabel: {
      type: String,
      default() {
        return this.$t("Components.DataTable.MassActionSelectedLabel");
      }
    },
    massActionSelectLabel: {
      type: String,
      default() {
        return this.$t("Components.DataTable.MassActionSelectActionLabel");
      }
    }
  }
};
</script>
